import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { deleteMerchant as deleteMerchantApi } from "../api/merchant.api";

interface UseDeleteMerchantReturn {
  deleteMerchant: (id: string) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useDeleteMerchant = (): UseDeleteMerchantReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteMerchant = useCallback(async (id: string): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      await deleteMerchantApi(id);
    } catch (deleteError: unknown) {
      setError(getApiErrorMessage(deleteError, "Failed to delete merchant"));
      throw deleteError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteMerchant, loading, error };
};
